export default "__VITE_ASSET__DUmVJRqM__"